(function () {
    'use strict';

    angular
        .module('franchiser.services')
        .service('JuridicalDocumentService', JuridicalDocumentService)

    /** @ngInject */
    function JuridicalDocumentService(HttpService) {
        const JuridicalDocumentService = {
            getTypes: getTypes,
            post: post,
            put: put,
            delete: qdelete
        }

        return JuridicalDocumentService;

        function getTypes() {
            return HttpService.get('/juridical/types');
        }

        function post(juridicalDocumentData) {
            return HttpService.post('/juridical', juridicalDocumentData);
        }

        function put(juridicalDocumentData) {
            return HttpService.put('/juridical', juridicalDocumentData);
        }

        function qdelete(juridicalDocumentId) {
            return HttpService.delete(`/juridical/${juridicalDocumentId}`);
        }
    }
}());